<template>
  <div>
    <v-layout row wrap justify-space-between>
      <v-flex xs7 sm7 md7>
        <v-card flat class="custom-card">
          <v-card-text>
            <v-layout justify-space-between wrap>
              <v-flex xs6 sm6 md6 v-for="form in formProduct" :key="form.label" class="pa-1">
                <div class="body-2 ma-2 grey--text">{{ form.label }}</div>
                <v-text-field
                  v-if="form.type === 'text'"
                  class="custom-text-field-owner"
                  :label="form.label"
                  :placeholder="form.label"
                  solo
                  flat
                  v-model="product[form.id]"
                ></v-text-field>
                <v-select
                  v-if="form.type === 'select'"
                  :items="form.data"
                  :label="form.label"
                  solo
                  item-text="label"
                  item-value="value"
                  flat
                  class="custom-select"
                  v-model="product[form.id]"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout justify-space-between wrap>
              <v-flex xs12 sm12 md12 class="pa-1">
                <div class="body-2 ma-2 grey--text">Description</div>
                <v-textarea
                  v-model="product['description']"
                  label="Default"
                  hint="Hint text"
                  solo
                  flat
                  class="custom-text-field-owner"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs4 sm4 md5 class="pl-2">
        <v-card flat class="custom-card">
          <v-card-text>
            <v-layout justify-space-between wrap>
              <v-flex xs12 sm12 md12 class="pa-1">
                <div class="body-2 ma-2 grey--text">Picture</div>
                <v-layout row justify-space-between>
                  <v-img
                    width="100"
                    height="auto"
                    position="top center"
                    :src="product.picture"
                    aspect-ratio="2"
                    class="grey lighten-2"
                    contain
                  ></v-img>
                  <v-btn color="blue-grey" class="white--text" @click="onPickFile('picture')">
                    <v-icon left dark>cloud_upload</v-icon>Change
                  </v-btn>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInputPicture"
                    accept="image/*"
                    @change="(event) => onFilePicked(event, 'picture')"
                  />
                </v-layout>
                <div class="body-2 ma-2 grey--text">Thumbnail</div>
                <v-layout row justify-space-between>
                  <v-img
                    width="100"
                    height="auto"
                    position="top center"
                    :src="product.thumbnail"
                    aspect-ratio="2"
                    class="grey lighten-2"
                    contain
                  ></v-img>
                  <v-btn color="blue-grey" class="white--text" @click="onPickFile('thumbnail')">
                    <v-icon left dark>cloud_upload</v-icon>Change
                  </v-btn>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInputThumbnail"
                    accept="image/*"
                    @change="(event) => onFilePicked(event, 'thumbnail')"
                  />
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <br />

    <v-card flat class="custom-card">
      <v-card-text>
        <div class="title mb-2">Basic Pricing</div>
        <v-layout justify-space-between wrap>
          <v-flex xs12 sm5 md4 v-for="form in formBasicPricing" :key="form.label" class="pa-1">
            <div class="body-2 mx-2 grey--text">{{ form.label }}</div>
            <v-text-field
              v-if="form.type === 'text' || form.type === 'email'"
              class="custom-text-field-owner"
              :label="form.label"
              :placeholder="form.label"
              :type="form.type"
              solo
              flat
              v-model="product[form.id]"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <br />

    <v-card flat class="custom-card">
      <v-card-text>
        <div class="title mb-2">Data Toko Utama</div>
        <v-layout justify-space-between wrap>
          <v-flex xs12 sm5 md4 v-for="form in formPriceTier" :key="form.label" class="pa-1">
            <div class="body-2 mx-2 grey--text">{{ form.label }}</div>
            <v-text-field
              v-if="form.type === 'text'"
              class="custom-text-field-owner"
              :label="form.label"
              :placeholder="form.label"
              solo
              flat
              v-model="product[form.id]"
            ></v-text-field>
            <v-select
              v-if="form.type === 'select'"
              :items="form.data"
              :label="form.label"
              solo
              item-text="label"
              item-value="value"
              flat
              class="custom-select"
              v-model="product[form.id]"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["product"],
  name: "Owner",
  data() {
    return {
      itemsCustomerType: [
        { label: "Big Retail", value: 0 },
        { label: "Retail", value: 1 },
        { label: "Semi Grosir", value: 2 },
        { label: "Grosir", value: 3 }
      ],
      itemsBarcode: [
        { label: "Barcode 1", value: 0 },
        { label: "Barcode 2", value: 1 }
      ],
      itemsBrand: [
        { label: "Brand 1", value: 0 },
        { label: "Brand 2", value: 1 }
      ],
      itemsCategory: [
        { label: "Category 1", value: 0 },
        { label: "Category 2", value: 1 }
      ],
      itemsQtyTier: [
        { label: "Qty Tier 1", value: 0 },
        { label: "Qty Tier 2", value: 1 }
      ],
      owner: {
        is_active: true
      },
      valid: true,
      picture: "",
      thumbnail: "",
      image: null
    };
  },
  computed: {
    formProduct() {
      return [
        {
          type: "text",
          id: "item_name",
          label: "Name",
          isRequired: false,
          rules: [v => !!v || "Name is required"]
        },
        {
          type: "null",
          id: "product_type",
          label: ""
        },
        {
          type: "select",
          id: "barcode",
          label: "Barcode",
          isRequired: false,
          data: this.itemsBarcode,
          rules: [
            v => {
              if (v == undefined) {
                return !!v || "Barcode is required";
              }
              return true;
            }
          ]
        },
        {
          type: "select",
          id: "brand_id",
          label: "Brand",
          isRequired: false,
          data: this.itemsBrand,
          rules: [
            v => {
              if (v == undefined) {
                return !!v || "Brand is required";
              }
              return true;
            }
          ]
        },
        {
          type: "text",
          id: "sku",
          label: "SKU",
          isRequired: false,
          rules: [v => !!v || "SKU is required"]
        },
        {
          type: "text",
          id: "principal_id",
          label: "Principal",
          isRequired: false,
          rules: [v => !!v || "principal is required"]
        },
        {
          type: "select",
          id: "kategori_id",
          label: "Category",
          isRequired: false,
          data: this.itemsCategory,
          rules: [
            v => {
              if (v == undefined) {
                return !!v || "Category is required";
              }
              return true;
            }
          ]
        },
        {
          type: "text",
          id: "tags",
          label: "Tag",
          isRequired: false,
          rules: [v => !!v || "Tag is required"]
        }
      ];
    },
    formBasicPricing() {
      return [
        {
          type: "text",
          id: "uom_code",
          label: "UOM Code",
          isRequired: false,
          rules: [v => !!v || "UOM Code is required"]
        },
        {
          type: "text",
          id: "uom_name",
          label: "UOM Name",
          isRequired: false,
          rules: [v => !!v || "UOM Name is required"]
        },
        {
          type: "text",
          id: "conversation_qty",
          label: "Conversation Qty",
          isRequired: false,
          rules: [v => !!v || "Conversation QTY is required"]
        },
        {
          type: "text",
          id: "normal_price",
          label: "Normal Price",
          isRequired: false,
          rules: [v => !!v || "Normal Price is required"]
        },
        {
          type: "text",
          id: "item_price",
          label: "Item Price",
          isRequired: false,
          rules: [v => !!v || "Item Price is required"]
        },
        {
          type: "text",
          id: "het_price",
          label: "Het Price",
          isRequired: false,
          rules: [v => !!v || "Het Price is required"]
        }
      ];
    },
    formPriceTier() {
      return [
        {
          type: "select",
          id: "qty_tier",
          label: "Qty Tier",
          isRequired: false,
          data: this.itemsQtyTier,
          rules: [
            v => {
              if (v == undefined) {
                return !!v || "Qty Tier is required";
              }
              return true;
            }
          ]
        },
        {
          type: "text",
          id: "discount_tier",
          label: "Discount Tier",
          isRequired: false
        },
        {
          type: "text",
          id: "periodic_stock",
          label: "Periodic Stock",
          isRequired: false
        }
      ];
    }
  },
  methods: {
    onPickFile(params) {
      if (params == "picture") {
        this.$refs.fileInputPicture.click();
      } else {
        this.$refs.fileInputThumbnail.click();
      }
    },
    onFilePicked(event, params) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        if (params == "picture") {
          this.product.picture = fileReader.result;
        } else if (params == "thumbnail") {
          this.product.thumbnail = fileReader.result;
        }
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
    }
  }
};
</script>

<style>
.custom-card {
  border: 1px solid #cfcfcf !important;
  background-color: #ffffff;
}
.custom-select .v-input__slot {
  border: 1px solid #ced4da;
  min-height: auto !important;
}

.custom-text-field-owner .v-input__control .v-text-field__details {
  margin: 0px;
}
.custom-text-field-owner .v-input__control .v-input__slot {
  border: 1px solid #ced4da;
  min-height: auto !important;
  margin: 0px;
}
</style>
